import { QuoteToolContainer, QuoteToolTitle } from "../QuoteStyles";
import {
  Board,
  boardHasBeenPaidFor,
  Shipment,
} from "../../../../reducers/uploadedBoard";
import { useBoardFromContext } from "../../../../utils/hooks/commonly-stored/uploaded-board/board";
import { ShipmentsList } from "./ShipmentsStyles";
import { DEMO_BOARD_SLUG } from "../../../../constants/boards";
import Button from "../../../common/Button";
import { useAppSelector } from "../../../../utils/hooks/store";
import { ADMIN_GROUP, ENGINEER_GROUP } from "../../../../utils/group";
import ShipmentTools from "./ShipmentTools";
import React, { useState } from "react";
import Modal from "../../../common/Modal";
import ModalContentWithCloseButton from "../../../common/ModalContentWithCloseButton";
import AddOrEditShipment from "./AddOrEditShipment";
import { OrderState } from "../../../Orders/constants";
import { FakeLink } from "../../../../constants/Styles";
import ShipmentHistory from "./ShipmentHistory";
import useShipmentsFromContext from "../../../../utils/hooks/commonly-stored/uploaded-board/shipments";
import { FlashPCBCalendar } from "../../../common/FlashPCBDatePicker";

export default function Shipments() {
  const boardStuff = useBoardFromContext();
  const board = boardStuff.board as Board;
  const shipments = useShipmentsFromContext(board.id) as Shipment[];
  const isDemoBoard = board.id == DEMO_BOARD_SLUG;
  const [showAddShipmentTool, setShowAddShipmentTool] = useState(false);
  const { groups } = useAppSelector((state) => state.auth);
  const isAdminOrEngineer =
    groups.includes(ADMIN_GROUP) || groups.includes(ENGINEER_GROUP);
  const canEditShipments =
    (isAdminOrEngineer || !boardHasBeenPaidFor(board)) &&
    board.order_summary?.state != OrderState.CANCELED;
  const [seeHistory, setSeeHistory] = useState(false);
  const leadTimeOptions = shipments[0]?.lead_time_options;

  const closeAddShipmentTool = () => {
    setShowAddShipmentTool(false);
  };

  const closeHistoryModal = () => {
    setSeeHistory(false);
  };

  if (isDemoBoard) {
    return false;
  }

  const boardHasMultipleShipments = shipments.length > 1;

  return (
    <>
      <Modal isOpen={showAddShipmentTool} onRequestClose={closeAddShipmentTool}>
        <ModalContentWithCloseButton
          closeModal={closeAddShipmentTool}
          title={"Add shipment"}
        >
          <AddOrEditShipment onUpdate={closeAddShipmentTool} />
        </ModalContentWithCloseButton>
      </Modal>
      <Modal isOpen={seeHistory} onRequestClose={closeHistoryModal}>
        <ModalContentWithCloseButton
          closeModal={closeHistoryModal}
          title={"Shipment history"}
        >
          <ShipmentHistory />
        </ModalContentWithCloseButton>
      </Modal>
      <QuoteToolContainer>
        <QuoteToolTitle>Shipments</QuoteToolTitle>
        <ShipmentsList>
          {shipments.map((shipment) => {
            return (
              <ShipmentTools
                key={shipment.id}
                shipment={shipment}
                allowRemove={boardHasMultipleShipments}
              />
            );
          })}
          {canEditShipments && (
            <Button
              label={"Add shipment"}
              onClick={() => setShowAddShipmentTool(true)}
            />
          )}

          {leadTimeOptions !== undefined && (
            <FlashPCBCalendar
              leadTimeOptions={leadTimeOptions}
              shipments={shipments}
            />
          )}
          {isAdminOrEngineer && (
            <FakeLink onClick={() => setSeeHistory(true)}>See history</FakeLink>
          )}
        </ShipmentsList>
      </QuoteToolContainer>
    </>
  );
}
